<ng-container *transloco="let t; read: 'login'">
	<form-wrapper [header]="t('title')" *ngIf="!processingRequest; else loading">
		<form [formGroup]="loginForm" (ngSubmit)="stepNum==0 ? nextStep() : login()">
			<div *ngIf="stepNum==0">
				<div class="app-text__label-l">{{t('labelEmail')}}</div>
				<input type="text" formControlName="email" appAutofocus>
				<val-error controlNameToValidate="email">{{t('validationEmail')}}</val-error>
				<app-button class="mti-5" [disabled]="!stepValid" (click)="nextStep()">
					{{'buttons.next' | transloco}}
				</app-button>
			</div>
			<div *ngIf="stepNum==1">
				<div class="app-text__label-l">{{t('labelPassword')}}</div>
				<input type="password" formControlName="password" #passwordInput appAutofocus>
				<val-error controlNameToValidate="password">{{t('validationPassword')}}</val-error>
				<div class="mti-5 flex flex-jc-space-between flex-ai-center">
					<app-button [disabled]="!loginForm.valid" (click)="login()">
						{{'buttons.login' | transloco}}
					</app-button>
					<a routerLink="/password-reset-form" queryParamsHandling="preserve" class="app-text__body-s ta-right">{{t('forgotPassword')}}</a>
				</div>
			</div>
		</form>
		<div *ngIf="stepNum==0">
			<div class="app-text__h3 mti-20 mbi-5">{{t('externalAccount')}}</div>
			<app-external-login></app-external-login>
			<div class="app-text__h3 mti-20 mbi-5">{{t('noAccount')}}</div>
			<app-button appearance="outline" size="s" routerLink="/register" queryParamsHandling="merge">
				{{'buttons.register' | transloco}}
			</app-button>
		</div>
	</form-wrapper>
</ng-container>

<ng-template #loading>
	<div class="flex flex-jc-center mti-19">
		<app-loader [loading]="true">
		</app-loader>
	</div>
</ng-template>